<template>
    <div class="d-flex flex-column justify-start align-center overflow-x-hidden">
        <v-row align="center" justify="center" class="px-5 mb-2 mt-2 w-100" v-if="data.id">
            <v-row justify="start" align="center">
                <v-img
                    src="/img/user/soundicon.svg"
                    max-height="45px"
                    max-width="45px"
                    contain
                    class="main-sound-img cursor-pointer ma-3"
                    @click="readText(challengeContent)"
                ></v-img>
                <div
                    :class="`d-flex flex-col px-0 justify-start w-80 align-center ${isInitialReader ? 'text-h5': 'text-h6'} primary--text text-justify font-weight-medium`"
                    v-html="visualContent"
                >
                </div>
            </v-row>

            <v-row class="w-100 pa-0" align="center" justify="center" v-if="questionFormat !== 3">
                <v-col cols="12" v-for="(answer, index) of data.mdTestPreguntaRespuestases"
                       class="pa-0 transition-all" :key="index" data>
                    <TextOption
                        :answer="answer" :question="data" :selected="answer.id ===btnSelected.id"
                        :data-question-identifier="`question-${data.id}-answer-${answer.id}`"
                        @select="setSelectedBtn(answer.id, answer.id, answer.item)"></TextOption>
                </v-col>
            </v-row>
            <v-row class="w-100" align="center" justify="center" v-else>
                <ImageOption v-for="(answer, index) of data.mdTestPreguntaRespuestases"
                             class="pa-0 w-25 transition-all" :key="index"
                             :answer="answer" :question="data"
                             :selected="answer.id === btnSelected.id"
                             :data-question-identifier="`question-${data.id}-answer-${answer.id}`"
                             @select="setSelectedBtn(answer.id, answer.id, answer.item)"></ImageOption>
            </v-row>
        </v-row>
    </div>
</template>
<script>
    import TextOption from "../../../../core/utils/items/TextOption";
    import ImageOption from "../../../../core/utils/items/ImageOption";
    import SpeechSynthesis from "../../../../../mixins/SpeechSynthesis";
    import initialReaderValidation from "../../../../../mixins/InitialReaderValidation";

    export default {
        name: "QuestionItem",
        components: {ImageOption, TextOption},
        props: {
            data: {type: Object, default: null},
        },
        data() {
            return {
                btnSelected: {
                    id: null,
                    value: null,
                    secret: null,
                },
            }
        },
        computed: {
            questionFormat() {
                return this.data.questionTemplate ? this.data.questionTemplate.value : 1
            },
            visualContent() {
                return this.data.contenido.replace('_', `
                        <span class="completion-space mx-3 elevation-3 transition-all" id="question-${this.data.id}"></span>
                        `).replace(/_/g, '')
            },
            challengeContent() {
                return this.data.contenido.replace(/_/g, '.')
            }
        },
        methods: {
            setSelectedBtn(answerId, answerValue, answerSecret) {
                this.btnSelected.id = answerId
                this.btnSelected.value = answerValue
                this.btnSelected.secret = answerSecret
                if (this.questionFormat === 2) this.moveText();
                this.$emit('newSelection', this.btnSelected)
            },
            moveText() {
                const el = document.querySelector(`#question-${this.data.id}`);
                const text = this.data.mdTestPreguntaRespuestases.find(q => q.item === this.btnSelected.secret)
                if (el && text) el.textContent = text.contenido
            },
            timeout(ms) {
                return new Promise(resolve => setTimeout(resolve, ms))
            },
            queryElements(query = "") {
                return document.querySelectorAll(query)
            },
            getElementsByQuestionAndAnswer(questionId = 0, answerId = 0) {
                return questionId && answerId ? this.queryElements(`div:is([data-question-identifier=question-${questionId}-answer-${answerId}])`) : []
            },
            setWrongAnswer(questionId = 0, answerId = 0) {
                const vm = this;
                const elements = this.getElementsByQuestionAndAnswer(questionId, answerId)
                if (elements.length) {
                    elements.forEach(el => {
                        vm.setStyleForWrongAnswer(el)
                    })
                }
            },
            setCorrectAnswer(questionId = 0, answerId = 0) {
                const vm = this;
                const elements = this.getElementsByQuestionAndAnswer(questionId, answerId)
                if (elements.length) {
                    elements.forEach(el => {
                        vm.setStyleForCorrectAnswer(el)
                    })
                }
            },
            async setStyleForWrongAnswer(el = null) {
                if (el) {
                    el.classList.add('filter-gray');
                    await this.timeout(500);
                    el.classList.add('animated', 'fadeOut');
                    await this.timeout(500);
                    el.classList.add('d-none');
                    await this.timeout(200);
                    this.validateAndScaleOption();
                }
            },
            async setStyleForCorrectAnswer(el = null) {
                if (el) {
                    el.classList.add('correct', 'animated', 'bounce');
                    await this.timeout(1000);
                    el.classList.remove('bounce')
                }
            },
            cleanStyles() {
                const CLASSES_TO_CLEAN = '.correct, .d-none, .filter-gray, .scale-1, animated, fadeOut';
                const elements = this.queryElements(CLASSES_TO_CLEAN);
                if (elements.length) {
                    elements.forEach(el => {
                        el.classList.remove('correct', 'd-none', 'filter-gray', 'scale-1', 'animated', 'fadeOut')
                    })
                }
            },
            validateAndScaleOption() {
                const hiddenOptions = this.queryElements('.option.d-none');
                if (hiddenOptions.length && hiddenOptions.length === 2) {
                    const options = this.queryElements('.option');
                    options.forEach(el => {
                        if (!el.classList.contains('d-none')) el.classList.add('scale-1');
                    })
                }
            }
        },
        watch: {
            cleanSelection() {
                this.btnSelected = {
                    id: null,
                    value: null,
                    secret: null,
                }
            },
        },
        mixins: [SpeechSynthesis, initialReaderValidation]
    }
</script>
<style>
    .completion-space {
        padding: 10px;
        border: 1px solid #1e1c84;
        min-width: 20vh;
        height: 5vh;
        text-align: center;
        border-radius: 10px;
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }


    .option-btn {
        border: thin solid;
        border-color: #514773 !important;
        font-size: 0.9rem;
        max-width: 100%;
    }

    .option {
        transform: scale(.95);
    }

    .filter-gray {
        filter: grayscale(1);
    }

    .scale-1 {
        transform: scale(1.05) !important;
    }

    .correct .alternative {
        background: #147a06 !important;
        color: white !important;
    }

    .correct .alternative-image {
        border: #147a06 solid 1vh !important;
        color: white !important;
        transform: scale(1.1);
    }

</style>
